import React, { useState } from 'react';
import { useGet } from 'ccstate-react';
import { fileExplorerState } from '../state/fileExplorerState';
import { TopNavigation, Sidebar, FileGrid, FileList, Toolbar } from '../components';
import type { FileItem } from '../../common/schema/schemaType';
export default function FileExplorerPage() {
    const viewMode = useGet(fileExplorerState.viewMode$);
    const [contextMenu, setContextMenu] = useState<{
        file: FileItem;
        x: number;
        y: number;
    } | null>(null);
    const handleFileRightClick = (file: FileItem, event: React.MouseEvent) => {
        event.preventDefault();
        setContextMenu({
            file,
            x: event.clientX,
            y: event.clientY
        });
    };
    const handleCloseContextMenu = () => {
        setContextMenu(null);
    };
    return (<div className="font-[-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Helvetica Neue',Arial,sans-serif] leading-[1.4] h-screen flex flex-col bg-[#F7F9FC]" onClick={handleCloseContextMenu} data-testid="file-explorer-page" data-id="qy1itl">
      {/* Header */}
      <TopNavigation data-id="uvo4cm"/>

      {/* Content Container */}
      <div className="w-full flex flex-1 overflow-hidden" data-id="mn4mnc">
        {/* Left Sidebar */}
        <Sidebar data-id="8yj15q"/>

        {/* Main Content Area */}
        <div className="flex-1 overflow-x-hidden bg-[#F7F9FC] flex flex-col" data-id="jlmbic">
          {/* Toolbar (shows when files are selected) */}
          <Toolbar data-id="i61kq9"/>

          {/* File Display Area */}
          <div className="flex-1 overflow-auto" data-id="2k97ay">
            {viewMode === 'grid' ? (<FileGrid onFileRightClick={handleFileRightClick} data-id="ixylks"/>) : (<FileList onFileRightClick={handleFileRightClick} data-id="jp33wo"/>)}
          </div>
        </div>
      </div>

      {/* Context Menu */}
      {contextMenu && (<div className="fixed bg-white border border-[#E0E7EF] rounded-md shadow-[0_4px_12px_rgba(26,43,61,0.12)] py-2 z-50 min-w-[180px]" style={{
                left: contextMenu.x,
                top: contextMenu.y
            }} onClick={(e) => e.stopPropagation()} data-testid="context-menu" data-id="2ermrc">
          <button className="w-full px-4 py-2 text-left text-sm text-[#1A2B3D] hover:bg-[#F0F4F8] flex items-center gap-3" data-id="44u1k4">
            <span className="w-4 h-4" data-id="btxke7">📂</span>
            Open
          </button>
          <button className="w-full px-4 py-2 text-left text-sm text-[#1A2B3D] hover:bg-[#F0F4F8] flex items-center gap-3" data-id="elocut">
            <span className="w-4 h-4" data-id="7vtz8m">✏️</span>
            Rename
          </button>
          <button className="w-full px-4 py-2 text-left text-sm text-[#1A2B3D] hover:bg-[#F0F4F8] flex items-center gap-3" data-id="cx7eif">
            <span className="w-4 h-4" data-id="llfype">📋</span>
            Move to
          </button>
          <button className="w-full px-4 py-2 text-left text-sm text-[#1A2B3D] hover:bg-[#F0F4F8] flex items-center gap-3" data-id="r8y9fh">
            <span className="w-4 h-4" data-id="o85mox">📄</span>
            Copy
          </button>
          <button className="w-full px-4 py-2 text-left text-sm text-[#1A2B3D] hover:bg-[#F0F4F8] flex items-center gap-3" data-id="w5w4kw">
            <span className="w-4 h-4" data-id="prbitw">⬇️</span>
            Download
          </button>
          <button className="w-full px-4 py-2 text-left text-sm text-[#1A2B3D] hover:bg-[#F0F4F8] flex items-center gap-3" data-id="gy83y7">
            <span className="w-4 h-4" data-id="odslr4">👥</span>
            Share
          </button>
          <div className="border-t border-[#E0E7EF] my-1" data-id="2p202x"/>
          <button className="w-full px-4 py-2 text-left text-sm text-[#E53935] hover:bg-[#FFEBEE] flex items-center gap-3" data-id="phomk3">
            <span className="w-4 h-4" data-id="iupdid">🗑️</span>
            Delete
          </button>
          <button className="w-full px-4 py-2 text-left text-sm text-[#1A2B3D] hover:bg-[#F0F4F8] flex items-center gap-3" data-id="huytsq">
            <span className="w-4 h-4" data-id="pwf5b9">ℹ️</span>
            Properties
          </button>
        </div>)}
    </div>);
}
